// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"99201fa8","635":"d0186339"}[chunkId] + ".chunk.js";
};